import { AuthGuard } from '../../../../../common/services/Auth.guard';
import { TicketsComponent } from './tickets.component';
import { TicketTypeComponent } from './ticket-type/ticket-type.component';
import { PriorityComponent } from './priority/priority.component';
import { PropertiesComponent } from './properties/properties.component';
import { ServicesComponent } from './service/service.component';
import { AnswerTemplateComponent } from './answertemplate/answer-template.component';

export const TicketSettingsRoute = [
  {
    path: 'ticket',
    component: TicketsComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'type', pathMatch: 'full' },
      {
        path: 'type',
        component: TicketTypeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'priority',
        component: PriorityComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'property',
        component: PropertiesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'service',
        component: ServicesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'template',
        component: AnswerTemplateComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/ticket.route.ts